
namespace appn.views.appBuilder.launchOptions {

    class InitArgs {
        appCode: string = emptyString;
        deepLinkPrefix: string = emptyString;
        buildIcon: string = emptyString;
        firstRun: boolean = false;
        screenTypes: string = emptyString;
        exportLaunchOptions: string = emptyString;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;

        // this doesn't do anything
        // if (args.firstRun)
        //    (appn as any).loadFirstTimeHelp();

        addEvents();
    }

    function addEvents(): void {
        $('.btnAddLaunchRule').on('click', function(event) {
            event.preventDefault();

            // Clear out the no data message and enable save button
            if ($('tbody .dataTables_noData').length)
                $('tbody').html(emptyString);

            $('.btn-save').removeClass('d-none');

            const idx = $('#dtItemsOptions tbody').children().length;

            $('#dtItemsOptions tbody').append(rowBuilder(idx));
            addControls();
            
            select.init({
                selector: `#AppConfig_LaunchOptions_LaunchRules_${idx}__InteractTarget`
            });
        });

        $('#exportLaunchOptions').click(function (event) {
            event.preventDefault();

            appn.ajax.get({
                url: _initArgs.exportLaunchOptions,
                data: { },
                done: function () {
                    (parent as any).appn.notifications.updateNotificationTotal();
                    ui.showExportConfirmation('Launch Options');
                }
            });
        });

        $('#importLaunchOptions').click(function (e) {
            e.preventDefault();
            $('#importDialog').modal('show');
        });

        addControls();
    }

    function addControls(): void {
        $('.delete_button').off().on('click', function() {
            $(this).parents('tr').remove();

            renameRows();
        });

        $('.buildIcon').off().on('click', function() {
            const icon = $(this);
            const incomingValueParams = String($(this).closest('tr').find('.dataCol.incomingValue input').val());

            setFormulaParamFields(incomingValueParams);

            const formulaInput = $(this).closest('.dataCol').find('textarea');

            appn.ui.formulabuilder.currentFormula = formulaInput.val() as string;
            appn.ui.formulabuilder.currentMode = icon.data('type');
            appn.ui.formulabuilder.formulaUpdated = function(formula: string) {
                formulaInput.val(formula);
            };
            
            appn.ui.formulabuilder.showDialog();
        });
    }

    function rowBuilder(idx: number): string {
        return '<tr><td class="dataCol incomingValue"><div class="input-group input-group-sm"><div class="input-group-prepend">' +
            `<span class="input-group-text">${_initArgs.deepLinkPrefix}</span>` +
            '</div>' +
            `<input class="form-control form-control-sm tableData" id="AppConfig_LaunchOptions_LaunchRules_${idx}__IncomingValue" name="AppConfig.LaunchOptions.LaunchRules[${idx}].IncomingValue" type="text"></input>` +
            '</div></td><td class="dataCol">' +
            `<select id="AppConfig_LaunchOptions_LaunchRules_${idx}__InteractTarget" name="AppConfig.LaunchOptions.LaunchRules[${idx}].InteractTarget"  class="form-control form-control-sm tableData">` +
            `<option value="">${strings.chooseScreen}</option>` +
            `${_initArgs.screenTypes}` + // This gets added by GetScreenTypeSelections() in AppBuilderController.cs
            '</select></td><td class="dataCol">' +
            `<input class="form-control form-control-sm tableData" id="AppConfig_LaunchOptions_LaunchRules_${idx}__InteractValue" name="AppConfig.LaunchOptions.LaunchRules[${idx}].InteractValue" type="text"></input>` +
            '</td><td class="dataCol"><div class="input-group input-group-sm">' +
            `<textarea rows="1" class="form-control form-control-sm tableData" id="AppConfig_LaunchOptions_LaunchRules_${idx}__Formula" name="AppConfig.LaunchOptions.LaunchRules[${idx}].Formula" type="text"></textarea>` +
            '<span class="input-group-append">' +
            appn.elementBuilder.buildIconButton('parameters') +
            `</span></div></td><td>${elementBuilder.buildBtnRemoveRow('delete_button')}</td></tr>`;
    }

    function setFormulaParamFields(url: string) {
        if (!url || url === null || url.length <= 0)
            return;

        // Splits the query string parameters into an array.
        let params = new Array<string>();

        if (url.containsIgnoreCase('?'))
            params = url.split('?')[1].split('&');

        $('#formulaFields').children('option').each(function(index, element) {
            if (String($(element).val()).length > 0)
                $(element).remove();
        });

        if (params && params !== null && params.length > 0)
            for (let i = 0; i < params.length; i++) {
                const param = params[i].split('=');
                $('#formulaFields').append(`<option value="${param[0]}">${param[0]}</option>`);
            }
    }

    function renameRows() {
        // Rename all remaining rows to keep continuous index after deleting a row
        let idx = 0;
        $('#dtItemsOptions tbody tr').each(function() {
            $(this).find('td.dataCol').each(function() {
                const input = $(this).find('.tableData');
                input.attr('name', String(input.attr('name')).replace(/\d+/, String(idx)));
                input.attr('id', String(input.attr('id')).replace(/\d+/, String(idx)));
            });
            idx++;
        });
    }
}
